module.exports = __webpack_public_path__ + "img/2.02513d2b.jpg";